const { accountType } = require('@transfeeradev/api-enums');
const { accountType: pixAccountType } = require('@transfeeradev/api-enums/pix/bcb');
const PersonTypeService = require('./PersonTypeService');
const moment = require('@transfeeradev/moment');

class BtgPixService {
  constructor(sentryCaptureMessage) {
    this.sentryCaptureMessage = sentryCaptureMessage;
  }

  formatPixData(payload) {
    const value = Number(payload.body.amount);
    const qrcodeTxId = payload.body.transactionIdentification;
    const receiverPixKey = payload.body.creditParty.key || null;
    const end2endId = payload.body.endToEndId.trim();
    const idempotencyKey = payload.pactualId;
    const timestamp = payload.createTimestamp ? moment(payload.createTimestamp).format() : null;

    const receiver = {
      name: payload.body.creditParty.name,
      document: PersonTypeService.getCpfCnpjNumber(payload.body.creditParty.taxId),
      account_type: this._getAccountType(payload.body.creditParty.accountType),
      account: payload.body.creditParty.account.slice(0, -1),
      account_digit: payload.body.creditParty.account.slice(-1),
      agency: payload.body.creditParty.branch,
      bank: {
        id: null,
        code: null,
        ispb: payload.body.creditParty.bank,
        name: null
      }
    };
    const payer = {
      name: payload.body.debitParty.name,
      document: PersonTypeService.getCpfCnpjNumber(payload.body.debitParty.taxId),
      account_type: this._getAccountType(payload.body.debitParty.accountType),
      account: payload.body.debitParty.account.slice(0, -1),
      account_digit: payload.body.debitParty.account.slice(-1),
      agency: payload.body.debitParty.branch,
      bank: {
        id: null,
        code: null,
        ispb: payload.body.debitParty.bank,
        name: null
      }
    };

    const qrcode = qrcodeTxId ? { txid: qrcodeTxId } : null;
    const pix_key = receiverPixKey ? { key: receiverPixKey } : null;
    const pix_description = payload.body?.remittanceInformation || null;
    return {
      value,
      payer,
      receiver,
      qrcode,
      pix_key,
      pix_description,
      idempotency_key: idempotencyKey,
      end2end_id: end2endId,
      timestamp
    };
  }

  _getAccountType(value) {
    switch (value) {
      case pixAccountType.CHECKING_ACCOUNT:
        return accountType.CONTA_CORRENTE;
      case pixAccountType.SAVINGS_ACCOUNT:
        return accountType.CONTA_POUPANCA;
      case pixAccountType.SALARY_ACCOUNT:
        return accountType.CONTA_SALARIO;
      case pixAccountType.PAYMENT_ACCOUNT:
        return accountType.CONTA_PAGAMENTO;
    }

    if (this.sentryCaptureMessage) {
      this.sentryCaptureMessage(`Unknwon pix account type [${value}]`);
    }
    return null;
  }
}

module.exports = BtgPixService;
